<template>
  <v-col xl="3" lg="3" md="3" cols="12">
    <v-card flat height="100%">
      <v-card-subtitle class="pb-0 pt-2 caption">{{ title }}</v-card-subtitle>
      <v-card-title class="subtitle-2 pt-0 pb-2">{{ info }}</v-card-title>
    </v-card>
  </v-col>
</template>

<script>
export default {
  props: {
    info: String,
    title: String,
  },
};
</script>

<style>
</style>